<template>
    <modal
        v-bind="$props"
        @before-open="$emit('before-open', $event)"
        @opened="$emit('opened', $event)"
        @before-close="$emit('before-close', $event)"
        @closed="$emit('closed', $event)"
    >
        <div :class="contentClasses">
            <div class="absolute z-10 top-0 right-0 pt-4 pr-4" v-if="showCloseIcon">
                <button class="relative top-4 right-4" @click="$modal.hide(name)">
                    <img src="/spa/close.svg" class="h-4 w-4 opacity-50 hover:opacity-100" />
                </button>
            </div>
            <div :class="slotContainerClasses">
                <slot></slot>
            </div>
        </div>
    </modal>
</template>

<script>
    export default {
        props: {
            name: {
                required: true,
                type: String,
            },
            height: {
                required: false,
            },
            scrollable: {
                required: false,
                type: Boolean,
                default() {
                    return true;
                }
            },
            reset: {
                required: false,
                default() {
                    return true;
                }
            },
            width: {
                required: false,
                default() {
                    return 600;
                }
            },
            showCloseIcon: {
                required: false,
                type: Boolean,
                default() {
                    return true;
                },
            },
            shiftX: {
                required: false,
                type: Number,
                default() {
                    return .5;
                },
            },
            shiftY: {
                required: false,
                type: Number,
                default() {
                    return .5;
                },
            },
            classes: {
                required: false,
                type: String,
                default() {
                    return '';
                }
            },
            contentClasses: {
                required: false,
                type: String,
                default() {
                    return this.$spa.css.modal.content;
                }
            },
            transition: {
                required: false,
                type: String,
                default: 'vm-transition--modal'
            },
            slotContainerClasses: {
                required: false,
                type: String,
                default: () => "relative w-full"
            }
        }
    }
</script>